var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 17.5H5.83268C2.49935 17.5 1.66602 16.6667 1.66602 13.3333V6.66667C1.66602 3.33333 2.49935 2.5 5.83268 2.5H14.166C17.4993 2.5 18.3327 3.33333 18.3327 6.66667V13.3333C18.3327 16.6667 17.4993 17.5 14.166 17.5Z",
    stroke: "#757B82",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 6.66699H15.8327",
    stroke: "#757B82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10H15.8333",
    stroke: "#757B82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 13.333H15.8327",
    stroke: "#757B82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08255 9.40827C7.91558 9.40827 8.59089 8.73296 8.59089 7.89993C8.59089 7.0669 7.91558 6.3916 7.08255 6.3916C6.24952 6.3916 5.57422 7.0669 5.57422 7.89993C5.57422 8.73296 6.24952 9.40827 7.08255 9.40827Z",
    stroke: "#757B82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 13.6085C9.88268 12.4001 8.92435 11.4501 7.71602 11.3418C7.29935 11.3001 6.87435 11.3001 6.44935 11.3418C5.24102 11.4585 4.28268 12.4001 4.16602 13.6085",
    stroke: "#757B82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalcard);
export default __webpack_public_path__ + "static/media/personalcard.74d14c2d9e52789f0fd46bc3dc15bc72.svg";
export { ForwardRef as ReactComponent };